import axiosService from "../services/axiosService";
const axios = axiosService.getInstance()
import axiosBase from 'axios'
const config = process.env.VUE_APP_ui_api_url
export default {
  actions: {
    async removeObjectAction(context, objectId) {
      return await axios.post(`/api/Device/RemoveObject/${objectId}`)
      .then((response) => {
        if(response.data.result.code == 0){
          return response.data
        }else{
          throw response.data.result
        }
      })
      .catch((err) => {
        throw err
      })
    },
    async createTariff(context, body) {
      return await axios.post(`/api/Device/CreateTariff`, body)
      .then((response) => {
        if(response.data.result.code == 0){
          return response.data
        }else{
          throw response.data.result
        }
      })
      .catch((err) => {
        throw err
      })
    },
    async getDataForChart(context, body) {
      return await axios.post(`/api/Device/GetDataForChart`, body)
      .then((response) => {
        if(response.data.result.code == 0){
          return response.data
        }else{
          throw response.data.result
        }
      })
      .catch((err) => {
        console.log(err)
        throw err
      })
    },
    async getDevices(context) {
      return await axios.get(`/api/Device/GetSubjects`)
      .then((response) => {
        if(response.data.result.code == 0){
          context.commit('loadDevices', response.data.subjects)
          context.commit('allLoad')
          return response.data
        }else{
          context.commit('loadDevices', [])
          context.commit('allLoad')
        }
      })
      .catch((err) => {
        console.log(err)
      })
    },
    async getDeviceTypesAction(context) {
      return await axiosBase.get(`${config}/api/Device/GetDeviceTypes`)
      .then((response) => {
        console.log(response)
        if(response.data.result.code == 0){
          context.commit('loadDeviceTypes', response.data.deviceTypes)
          context.commit('allLoad')
          return response.data
        }else{
          throw response.data.result
          throw err
        }
      })
      .catch((err) => {
        console.log(err)
      })
    },
    async getSubDeviceTypesAction(context) {
      return await axiosBase.get(`${config}/api/Device/GetSubDeviceTypes`)
      .then((response) => {
        if(response.data.result.code == 0){
          context.commit('loadSubDeviceTypes', response.data.subDeviceTypes)
          context.commit('allLoad')
          return response.data
        }else{
          throw response.data.result
        }
      })
      .catch((err) => {
        console.log(err)
        throw err
      })
    },
    async getSubjectCreationData(context) {
      return await axiosBase.get(`${config}/api/Device/GetSubjectCreationData`)
      .then((response) => {
        if(response.data.result.code == 0){
          console.log(response)
          response.data.importanceRank.unshift({
            name: 'All',
            id: null
          })

          //All simcorps
          response.data.simCorps.unshift({
            name: 'All',
            id: null
          })

          // response.data.providers.unshift({
          //   name: 'No provider',
          //   id: 0
          // })
          response.data.providers.unshift({
            name: 'All',
            id: null
          })

          // response.data.suppliers.unshift({
          //   title: 'No resource supplier',
          //   id: 0
          // })
          response.data.suppliers.unshift({
            title: 'All',
            id: null
          })
          // response.data.simCorps.unshift({
          //   name: 'Sim corporation not selected',
          //   id: null
          // })
          
          response.data.tariffs.forEach(tr => {
            const m = response.data.measureTypes.filter(m => m.id == tr.measureTypeId)[0]
            tr.fakeName = `${tr.description} / ${m.value}`
          })
          context.commit('loadSubjectCreationData', response.data)
          context.commit('allLoad')
          return response.data
        }else{
          throw response.data.result
        }
      })
      .catch((err) => {
        console.log(err)
        throw err
      })
    },
    async createUserSubject(context, body) {
      return await axiosBase.post(`${config}/api/Device/CreateUserSubject`, body)
      .then((response) => {
        if(response.data.result.code == 0){
          console.log(response)
          return response.data
        }else{
          throw response.data.result
        }
      })
      .catch((err) => {
        console.log(err)
        throw err
      })
    },
    async createSubject(context, body) {
      return await axios.post(`/api/Device/CreateSubject`, body)
      .then((response) => {
        if(response.data.result.code == 0){
          console.log(response)
          return response.data
        }else{
          throw response.data.result
        }
      })
      .catch((err) => {
        console.log(err)
        throw err
      })
    },
    async getLocationInfo(context, data) {
      return await axiosBase.get(`https://nominatim.openstreetmap.org/search?q=${data.replace(" ", "+")}&format=json&polygon_geojson=15&addressdetails=1`)
      .then((response) => {
        return response
      })
      .catch((err) => {
        throw err
      })
    },
    async getDeviceSensors(context, deviceId) {
      return await axios.get(`/api/Device/GetSensorTypes/${deviceId}`)
      .then((response) => {
        console.log(response)
        if(response.data.result.code == 0){
          return response.data
        }else{
          throw response.data.result
        }
      })
      .catch((err) => {
        throw err
      })
    },
    async getEventTypes(context) {
      return await axios.get(`/api/Device/GetEventTypes/`)
      .then((response) => {
        console.log(response)
        if(response.data.result.code == 0){
          return response.data
        }else{
          throw response.data.result
        }
      })
      .catch((err) => {
        throw err
      })
    },
    async getEventsApi(context, body) {
      return await axios.post(`/api/Device/GetEvents/`, body)
      .then((response) => {
        if(response.data.result.code == 0){
          return response.data
        }else{
          throw response.data.result
        }
      })
      .catch((err) => {
        throw err
      })
    },
    async GetReport(context, body) {
      return await axios.post(`/api/Device/GetReport/`, body)
      .then((response) => {
        if(response.data.result.code == 0){
          return response.data
        }else{
          throw response.data.result
        }
      })
      .catch((err) => {
        throw err
      })
    },
    async updateSubject(context, body) {
      return await axios.post(`/api/Device/UpdateSubject/`, body)
      .then((response) => {
        if(response.data.result.code == 0){
          return response.data
        }else{
          throw response.data.result
        }
      })
      .catch((err) => {
        throw err
      })
    }
  },
  state: {
    selectedDevice: null,
    devices: null,
    deviceTypes: [],
    subDeviceTypes: [],
    subjectCreationData: null
  },
  mutations: {
    selectDevice(state, data){
      state.selectedDevice = data
    },
    updateDeviceGps(state, data){
      state.devices.forEach(d => {
        if(d.deviceId == data.DeviceId){
          d.address.latitude = data.Latitude
          d.address.longitude = data.Longitude
        }
      })
    },
    loadDevices(state, devices){
      state.devices = devices
    },
    loadSubDeviceTypes(state, subDeviceTypes){
      /*if(state.deviceTypes.length > 0){
        subDeviceTypes
      }*/
      state.subDeviceTypes = subDeviceTypes
    },
    loadDeviceTypes(state, deviceTypes){
      state.deviceTypes = deviceTypes
    },
    loadSubjectCreationData(state, data){
      state.subjectCreationData = data
    },
  },
  getters: {
    getSelectedDevice(state){
      return state.selectedDevice
    },
    getDeviceTypes(state){
      return state.deviceTypes
    },
    getSubDeviceTypes(state){
      return state.subDeviceTypes
    },
    getSubjectCreationDatas(state){
      return state.subjectCreationData
    },
    getDevicesData(state){
      return state.devices
    }
  }
}